import React from 'react';
import { useEditorStore } from '../../stores/editorStore';
import { useSettingsStore } from '../../stores/settingsStore';

// SVG noise texture as data URI
const noiseDataUri = `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`;

const OutroCard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div 
      className="h-full rounded-2xl p-4 flex flex-col relative overflow-hidden"
      style={{ 
        backgroundColor: '#0f0f0f',
        border: '3px solid rgba(255, 255, 255, 0.2)' 
      }}
    >
      {/* Subtle accent */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse at 0% 0%, rgba(107, 114, 128, 0.15) 0%, transparent 50%)',
        }}
      />
      
      {/* Noise texture overlay */}
      <div 
        className="absolute inset-0 pointer-events-none opacity-[0.04]"
        style={{
          backgroundImage: noiseDataUri,
          backgroundRepeat: 'repeat',
        }}
      />

      {/* Vignette overlay */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse at center, transparent 40%, rgba(0,0,0,0.4) 100%)',
        }}
      />
      
      {/* Content */}
      <div className="flex-1 flex flex-col items-center justify-center relative z-10">
        {children}
      </div>
    </div>
  );
};

interface OutroViewProps {
  isPresentation?: boolean;
}

export const OutroView: React.FC<OutroViewProps> = ({ isPresentation: _isPresentation = false }) => {
  const { currentEpisode } = useEditorStore();
  const { settings } = useSettingsStore();

  return (
    <div className="w-full h-full flex flex-col justify-center bg-black p-8">
      {/* Title */}
      <h1 className="text-5xl font-bold mb-8">
        <span style={{ color: settings.accentColor }}>{currentEpisode?.showTitle || settings.showName}</span>
        <span className="text-white"> : Merci d'avoir regardé !</span>
      </h1>
      
      {/* Two cards layout */}
      <div className="flex gap-6" style={{ height: '55%' }}>
        {/* YouTube suggestion card */}
        <div className="flex-1">
          <OutroCard>
            <div className="w-full h-1/2 flex items-center justify-center">
              <div className="w-3/4 aspect-video bg-black/50 rounded-xl flex items-center justify-center border-2 border-dashed border-white/20">
                <span className="text-6xl">📺</span>
              </div>
            </div>

          </OutroCard>
        </div>
        
        {/* CTA card */}
        <div className="flex-1">
          <OutroCard>
            <h3 className="text-white font-bold text-center text-4xl px-4">
              Abonnez-vous et likez la vidéo
            </h3>
            <div className="flex gap-6 mt-8">
              <span className="text-6xl">👍</span>
              <span className="text-6xl">🔔</span>
            </div>
          </OutroCard>
        </div>
      </div>
    </div>
  );
};
